/// <reference path="../../../typings/tsd.d.ts" /> 
module warsApp.models {
    export class Coordinate {
        public x: number;
        public y: number;

        constructor(x: number, y: number) {
            this.x = x;
            this.y = y;
        }

        public equals(coordinate: Coordinate) {
            if (!coordinate) return false;
            return this.x === coordinate.x && this.y === coordinate.y;
        }
    }
}